import {settings} from '../../common/setting';

export function initPiwik() {
  if (settings.isPreview) {
    return;
  }
  if (window.$s_temp) {
    window.$s_temp.initPiwikPostUrl({
      matomoUrl: window.$sk_template.matomoUrl,
      apiUrl: window.$sk_template.apiUrl
    });
    if (window.stemplateConfig.tenantId) {
      window.$s_temp.initPiwikTenantId(window.stemplateConfig.tenantId);
    }
  }
}